import styled from "styled-components";
import { InputLabel } from "@material-ui/core";

export const Label = styled(InputLabel)`
    font-size: 0.8em;
    margin: 15px 0 5px;
`;

export default Label;
